import axios from "@/axios/axios";
import { ProjectDocument, ProjectDocumentFlat, StatsProjectDocument } from "@/interfaces/project.interfaces";

export async function fetchProjects(): Promise<ProjectDocument[]> {
  try {
    const res = await axios.get(`/prj/all`);
    return res ? res.data : [];
  } catch (e: any) {
    console.log('fetchProjects :', e.message);
    return [];
  }
}

export async function updateProject(prjid: string, body: Partial<ProjectDocumentFlat>): Promise<ProjectDocument | null> {
  try {
    const res = await axios.put(`/prj/${prjid}`, body);
    return res ? res.data : null;
  } catch (e: any) {
    console.log('updateProject :', e.message);
    return null;
  }
}

export async function createProject(body: Partial<ProjectDocumentFlat>): Promise<ProjectDocument | null> {
  try {
    const res = await axios.post(`/prj/add`, body);
    return res ? res.data : null;
  } catch (e: any) {
    console.log('createProject :', e.message);
    return null;
  }
}

export async function statsProject(prjid:string): Promise<StatsProjectDocument | null> {
  try {
    const res = await axios.get(`/stats/oneproject/${prjid}`);
    return res ? res.data : null;
  } catch (e: any) {
    console.log('statsProject :', e.message);
    return null;
  }
}
